import type { SelectValueType } from '~/presentation/reports/ui/type';
import type { IDynamicControlSetting } from './control';

// ---- Data Change ----
export type PayloadControlChange = Record<string, SelectValueType | undefined>;
export type IOnControlChangeResult = () => void;

const listeners = new Set<(p: PayloadControlChange) => void>();

export function emitControlChange(p: PayloadControlChange) {
  listeners.forEach((cb) => cb(p));
}

export function onControlChange(cb: (p: PayloadControlChange) => void): IOnControlChangeResult {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

// ---- UI Change ----
const uiListeners = new Set<(ui: IDynamicControlSetting) => void>();

export function emitControlUIChange(ui: IDynamicControlSetting) {
  uiListeners.forEach((cb) => cb(ui));
}

export function onControlUIChange(
  cb: (ui: IDynamicControlSetting) => void,
): IOnControlChangeResult {
  uiListeners.add(cb);
  return () => uiListeners.delete(cb);
}

// ---- Delete Control UI ----
const deleteListeners = new Set<(id: string) => void>();

export function emitDeleteControlUI(id: string) {
  deleteListeners.forEach((cb) => cb(id));
}

export function onDeleteControlUI(cb: (id: string) => void): IOnControlChangeResult {
  deleteListeners.add(cb);
  return () => deleteListeners.delete(cb);
}

// ---- reset Control data ----
const resetDataListeners = new Set<(controlIds: string[]) => void>();

export function emitResetControlData(controlIds: string[]) {
  resetDataListeners.forEach((cb) => cb(controlIds));
}

export function onResetControlData(cb: (controlIds: string[]) => void): IOnControlChangeResult {
  resetDataListeners.add(cb);
  return () => resetDataListeners.delete(cb);
}
